import * as audio from './audio.js';
import * as scene from './scene.js';

export {
    init,
    addClickableArea,
}

const clickableAreas = [];

let hovering = false;
const clickCoordinates = {};

function init() {
    const canvasElement = document.querySelector('canvas');
    canvasElement.addEventListener('click', (e) => {
        clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        clickCoordinates.y = e.clientY - canvasElement.offsetTop;

        clickableAreas.forEach(area => {
            if (
                clickCoordinates.x >= area.x &&
                clickCoordinates.x <= area.x + area.width &&
                clickCoordinates.y >= area.y &&
                clickCoordinates.y <= area.y + area.height
            ) {
                area.action();
            }
        });
    });

    canvasElement.addEventListener('mousemove', (e) => {
        clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        clickCoordinates.y = e.clientY - canvasElement.offsetTop;

        hovering = false;
        clickableAreas.forEach(area => {
            if (
                clickCoordinates.x >= area.x &&
                clickCoordinates.x <= area.x + area.width &&
                clickCoordinates.y >= area.y &&
                clickCoordinates.y <= area.y + area.height
            ) {
                hovering = true;
            }
        });

        canvasElement.style.cursor = hovering ? 'pointer' : 'default';
    });
}

function addClickableArea(area) {
    clickableAreas.push(area);
}